import { manifest as inModalManifest } from './in-modal/in-modal.condition.manifest.js';

export const manifests = [inModalManifest];
